import styled from "styled-components";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { convertCurrency, covertTimeZone, numberFormat } from "../../helper";
import { S3_URL, USER_KEY } from "../../const";
import { useLazyQuery } from "@apollo/client";
import { GET_SHOP } from "../../apollo/shop/Query";

export default function BillForCheckOut58({
  cartDatas,
  activeCart,
  selectedPayCurrency
}) {
  // const now = moment().format('DD/MM/YYYY, h:mm:ss A')
  const index = cartDatas.findIndex(item => item?.label === activeCart)
  const shop = JSON.parse(localStorage.getItem('SHOP_DATA'))
  // Set mutation state for input modal
  const [shopdata, setShopData] = useState();
  const [imgSrc, setImgSrc] = useState();
  // Query shop data from Apollo
  const [loadShop, { data: shopData, loadingShop }] = useLazyQuery(GET_SHOP, {
    fetchPolicy: "network-only",
  });


  useEffect(() => {
    _fetchShop();
  }, []);

  // Update shop data when shop data change
  useEffect(() => {
    if (shopData) setShopData(shopData?.shop);
    setImgSrc(S3_URL + shopData?.shop?.image);
  }, [shopData]);

  // console.log("-------------------", imgSrc)



  const _fetchShop = () => {
    const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
    loadShop({
      variables: {
        where: {
          id: shopId,
        },
      },
    });
  };

  const currentDateTime = new Date().toLocaleString();
  



  return (
    <Container>
        <div style={{ textAlign: "center" }}><b style={{ fontSize: "20px" }}>ຮ້ານ {shop?.name}</b></div>
        <div style={{ textAlign: "center" }}>{shop?.address?.village + ", " + shop?.address?.district + ", " + shop?.address?.province}</div>
        <div style={{ textAlign: "center" }}>{shop?.phone}</div>
        <div style={{ textAlign: "center" }}>
          <b style={{ fontSize: "25px" }}>ບິນເກັບເງີນ</b>
        </div>
        <div style={{ textAlign: "left" }}>ເລກທີບິນ : {cartDatas[index]?.data?.orderGroup?.code} </div>
        <div style={{ textAlign: "left" }}>ວັນທີ : {covertTimeZone(currentDateTime)}</div>
        <Name style={{ marginBottom: 10 }}>
          <div style={{ textAlign: "left" }}>ລາຍການ</div>
          <div style={{ textAlign: "center" }}>ຈຳນວນ</div>
          <div style={{ textAlign: "right" }}>ລາຄາ</div>
          <div style={{ textAlign: "right" }}>ລວມ</div>
          {/* <div style={{ textAlign: "right" }}>ສະກຸນເງີນ</div> */}
        </Name>
        <Order>

          {/* {cartDatas[index]?((item, index) => {
          return ( */}
          <>
            {
              cartDatas[index]?.data?.orders?.map((order, index) => (

                <div
                  style={{
                    // display: "flex",
                    // justifyContent: 'space-between',
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr",
                    fontSize: 12,
                  }}
                  key={index}
                >
                  <div style={{ textAlign: "left" }}>{index + 1} {order?.productName}</div>
                  <div style={{ textAlign: "center" }}>{order?.amount}</div>
                  <div style={{ textAlign: "right" }}>{order?.price ? numberFormat(order?.price) : "-"}</div>
                  <div style={{ textAlign: "right" }}>
                    {numberFormat(order?.price * order?.amount)}&emsp;
                    {order?.currency === "LAK" ? '₭' : order?.currency === "BAHT" ? 'B' : order?.currency === "USD" ? '$' : ''}
                  </div>
                </div>
              ))
            }

            <hr style={{ border: "1px solid #000" }} />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>ຍອດລວມ:</div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <span>
                  {numberFormat(cartDatas[index]?.data?.orderGroup?.totalPrice ?? 0)} ₭
                </span>
                <span>
                  {numberFormat(cartDatas[index]?.data?.orderGroup?.sumPriceBaht ?? 0)} B
                </span>
                <span>
                  {numberFormat(cartDatas[index]?.data?.orderGroup?.sumPriceUsd ?? 0)} $
                </span>
              </div>

            </div>

            {cartDatas[index]?.data?.orderGroup?.taxes?.taxStatus && (
              <>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>ລາຄາບໍ່ລວມອາກອນ</span>
                  <span>{numberFormat(cartDatas[index]?.data?.orderGroup?.taxes?.priceBeforeTax ?? 0)} ₭</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>
                    ອາກອນມູນຄ່າເພີ່ມ {cartDatas[index]?.data?.orderGroup?.taxes?.tax ?? 0}
                    {cartDatas[index]?.data?.orderGroup?.taxes?.taxType === "PERCENT" ? "%" : "₭"}
                  </span>
                  <span>{numberFormat(cartDatas[index]?.data?.orderGroup?.taxes?.taxAmount ?? 0)} ₭</span>
                </div>
              </>
            )}

            <hr style={{ border: "1px solid #000" }} />

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span> <b style={{ fontSize: "18px" }}>ຈຳນວນເງີນທີ່ຕອ້ງຈ່າຍ :</b></span>
              <b style={{ fontSize: "20px" }}> {numberFormat(cartDatas[index]?.data?.orderGroup?.sumPrice ?? 0)} {convertCurrency(selectedPayCurrency)}</b>
            </div>

            <hr style={{ border: "1px solid #FFFFFF" }} />
          </>
        </Order>

    </Container>
  );
}

const Name = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
`;
const Price = styled.div`
  display: flex;
`;
const Container = styled.div`
  //  margin-top: 1000px;
  width: 100%;
  /* maxwidth: 80mm; */
`;
const Img = styled.div`
  width: 90px;
  height: 90px;
  font-size: 14px;
`;
const Order = styled.div`
  display: flex;
  flex-direction: column;
`;


